import React, { useEffect } from 'react';
import styles from './Parts.module.scss';
import icons from '../../../assets';

function PartsDetail({ parts, setParts }) {
  const { RequestDeleteIcon } = icons;

  const handleDeleteClick = (_id) => {
    const tempParts = parts.filter((item) => item.id !== _id);
    const _parts = tempParts.map((item) => {
      if (item.id > _id) {
        item.id -= 1;
      }

      return item;
    });

    setParts(_parts);
  };

  const handleChange = (value, _id, isNote = false) => {
    const _parts = parts.map((item) => {
      if (item.id === _id) {
        if (isNote) item.note = value;
        else item.value = value;
      }
      return item;
    });
    setParts(_parts);
  };

  const handleKeyDown = (e) => {
    if (e.keyCode === 13 && !e.shiftKey) e.target.blur();
  };

  // useEffect(() => {
  //   parts.map((_item, index) => ({...parts, id:index +1}))
  // }, [])

  return (
    <div className="d-flex flex-column gap-3 p-3">
      {parts.length ? (
        parts.map((part) =>
          part?.name ? (
            <div className={styles.partsDetails}>
              <div onClick={() => handleDeleteClick(part.id)} className={styles.deleteIcon}>
                <RequestDeleteIcon />
              </div>
              <div className="d-flex gap-3 align-items-center">
                <div className={styles.index}>
                  <span>{part.id}</span>
                </div>
                <input
                  type="text"
                  placeholder="Enter name"
                  value={part.value}
                  onChange={(e) => handleChange(e.target.value, part.id)}
                  onKeyDown={handleKeyDown}
                />
              </div>
              {part?.note !== undefined ? (
                <textarea
                  value={part.note}
                  placeholder="Notes"
                  rows={3}
                  onChange={(e) => handleChange(e.target.value, part.id, true)}
                  onBlur={(e) => handleChange(e.target.value || undefined, part.id, true)}
                  onKeyDown={handleKeyDown}></textarea>
              ) : (
                <span className={styles.addNotes} onClick={() => handleChange('', part.id, true)}>
                  add notes
                </span>
              )}
            </div>
          ) : null
        )
      ) : (
        <h3 className="text-muted">No parts added.</h3>
      )}
    </div>
  );
}

export default PartsDetail;
